import React, { createContext, useContext, useState } from 'react';

const CONSENT_KEY = 'cookieConsent';

const ConsentContext = createContext(null);

export const ConsentProvider = ({ children }) => {
  const [consent, setConsentState] = useState(() => localStorage.getItem(CONSENT_KEY));

  const setConsent = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setConsentState(value);
  };

  return (
    <ConsentContext.Provider value={{ consent, setConsent }}>
      {children}
    </ConsentContext.Provider>
  );
};

export const useConsent = () => useContext(ConsentContext);